// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--3fG6k","form":"styles-module--form--3rb3b","column":"styles-module--column--2HRct"};